import { createContext, useState, useContext } from 'react';


export const AccomodationListContext = createContext();

export const AccomodationListContextProvider = ({ children }) => {
    const [compareEntries, setCompareEntries] = useState([]);
    const [showComparePopup, setShowComparePopup] = useState(false);

    const toggleCompare = entry => {
        if (compareEntries.find(el => el._id === entry._id)) {
            const newEntries = compareEntries.filter(el => el._id !== entry._id);
            setCompareEntries(newEntries);
            if (newEntries.length < 2) {
                setShowComparePopup(false);
            }
        } else {
            if (compareEntries.length < 3) {
                setCompareEntries([...compareEntries, entry]);
            }
        }
    };

    return (
        <AccomodationListContext.Provider
            value={{
                compareEntries,
                setCompareEntries,
                toggleCompare,
                showComparePopup,
                setShowComparePopup
            }}
        >
            {children}
        </AccomodationListContext.Provider>
    )
}

export const useAccomodationListContext = () => {
    return useContext(AccomodationListContext);
}
